var map = {
	"./en.svg": "ac65",
	"./es.svg": "bfe2",
	"./id.svg": "cf03",
	"./ja.svg": "b14f",
	"./lo.svg": "fbfc",
	"./th.svg": "ae5a",
	"./zh.svg": "8e5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c243";